import * as React from 'react';
import { Link, Navigate } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import PageContainer from '../common/PageContainer';
import { Router, Route } from 'react-router-dom';

import './index.scss';

import { AppContextState, IAppState } from '../context';
import Button from '../common/components/Interactive/Button'
import TextBox from '../common/components/Interactive/Input/TextBox';
import { deleteData, getData, getRolePowerName, postData, putData, setCookie } from '../libs/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faPhotoVideo, faUser } from '@fortawesome/free-solid-svg-icons';
import DashboardContainer from '../common/DashboardContainer';
import LoadingIcon from '../common/LoadingIcon';
import VideoPreviewModal from '../common/components/VideoPreview';
import InviteModal from './InviteModal';
import configs from '../configs';
import MemberDetailModal from './MemberModal';

type PageProps = {
};
type PageState = {
    loading: Boolean,
    memberList: Array<Object>,
    inviteList: Array<Object>,
    crrOpenActor?: string,
    crrOpenMemberModal?: string,
    lastKeywordSearch: string
    exiting: boolean,
    targetPath?: string
};
class MembersPage extends React.Component<PageProps, PageState, IAppState> {
    context!: IAppState;

    state = {
        loading: true,
        memberList: [],
        inviteList: [],
        crrOpenActor: undefined,
        crrOpenMemberModal: undefined,
        lastKeywordSearch: '',
        exiting: false,
        targetPath: undefined
    };

    componentDidMount() {
        this.getMemberList();
        this.getInviteList();
    }

    componentWillUnmount(): void {
        
    }

    componentDidUpdate(prevProps: Readonly<PageProps>, prevState: Readonly<PageState>, snapshot?: IAppState | undefined): void {
        // console.log(this.context.keywordSearchInput, this.state.lastKeywordSearch)
        if(this.context.keywordSearchInput !== this.state.lastKeywordSearch) {
            this.setState({
                loading: true,
                lastKeywordSearch: this.context.keywordSearchInput || ''
            });
            this.getMemberList();
        }
    }

    getMemberList = async () => {
        let result = await getData('/api/team/getTeamMembers?project_id=' + this.context.project.project?.project_id + '&keywords=' + this.context.keywordSearchInput)
        this.setState({
            loading: false
        })
        if(result.status === 200) {
            const data = await result.json();
            if(data.members) {
                
                // this.setState({
                //     videoList: data.files.map((item: any) => {
                //         return {
                //             title: item.file.title,
                //             duration: item.file.duration || 0,
                //             description: item.file.description || '',
                //             tags: item.tags.map((tag: any) => tag.tag.name ?? ''),
                //             source: "",
                //             thumbnail: item.file.thumbnail,
                //             ...item
                //         };
                //     })
                // })
                this.setState({
                    memberList: data.members
                })
            }
        }
    }

    getInviteList = async () => {
        let result = await getData('/api/team/getTeamMembers?project_id=' + this.context.project.project?.project_id + '&role_power=-1')
        this.setState({
            loading: false
        })
        if(result.status === 200) {
            const data = await result.json();
            if(data.members) {
                this.setState({
                    inviteList: data.members
                })
            }
        }
    }

    onUpdateMember = async (user_id: number, role_power: number) => {
        let result = await putData('/api/team/updateTeamMemberRole', {
            project_id: this.context.project.project?.project_id,
            user_id: user_id,
            role_power: role_power
        })
        if(result.status === 200) {
            const data = await result.json();
            this.getMemberList();
            this.getInviteList();
        }
    }

    onDeleteTeamMember = async (user_id: number) => {
        let result = await deleteData(`/api/team/deleteTeamMember?project_id=${this.context.project.project?.project_id}&user_id=${user_id}`)
        if(result.status === 200) {
            const data = await result.json();
            // this.getMemberList();
            // this.getInviteList();
        }
        this.getMemberList();
        this.getInviteList();
    }

    render() {
        return (
            <>
                {this.state.exiting && this.state.targetPath && (
                    <Navigate to={this.state.targetPath} replace={true} />
                )}
                <motion.div className="timeline"
                    initial={{ opacity: 0 }}
                    animate={{
                        opacity: 1,
                        transition: {
                            duration: 0.5,
                        }
                    }}
                    exit={{
                        opacity: 0,
                    }}
                >
                    <motion.div style={{
                        display: 'flex',
                        alignItems: 'center',
                    }}>
                        <p className='title'>Sorted by role</p>
                        { this.state.inviteList.length > 0 &&
                            <motion.div style={{
                                    paddingTop: 2,
                                    marginLeft: 20,
                                    height: 30,
                                }}
                                layoutId={'member-modal-a0-panel'}
                            >
                                <Button
                                    onClick={() => {
                                        this.setState({
                                            crrOpenActor: '0'
                                        })
                                    }}
                                >{this.state.inviteList.length} New Request</Button>
                            </motion.div>
                        }
                    </motion.div>
                    { this.state.crrOpenActor && <InviteModal
                        inviteList={this.state.inviteList}
                        onUpdateMember={(user_id: number, role_power: number) => {
                            if(role_power == 0) {
                                this.onDeleteTeamMember(user_id);
                                return;
                            }

                            this.onUpdateMember(user_id, role_power);
                        }}
                        onClose={(shouldRefresh: boolean) => {
                            this.setState({
                                crrOpenActor: undefined
                            })
                            this.getMemberList();
                            this.getInviteList();
                        }}
                    />}
                    
                    { this.state.crrOpenMemberModal && <MemberDetailModal
                        member_id={this.state.crrOpenMemberModal}
                        onClose={(shouldRefresh: boolean) => {
                            this.setState({
                                crrOpenMemberModal: undefined
                            })
                            this.getMemberList();
                            this.getInviteList();
                        }}
                    />}
                    { this.state.loading && <div className='loadingCenter'><LoadingIcon size={30}/></div>}
                    { !this.state.loading && this.state.memberList.length === 0 && <div className="no-footage" style={{
                        position: 'relative',
                        width: '100%',
                        height: '50vh',
                        opacity: .5
                    }}>
                        <div className='centerContain'>
                            <FontAwesomeIcon icon={faUser} fontSize={50}/>
                            <br/><br/>
                            <h1>No member found</h1>
                        </div>
                    </div>}
                    { !this.state.loading && this.state.memberList.length > 0 &&
                    
                        <motion.div
                            className='member-list'
                            initial={{ opacity: 0 }}
                            animate={{
                                opacity: 1,
                                transition: {
                                    duration: 0.5,
                                    delay: 0.2
                                }
                            }}
                            exit={{
                                opacity: 0,
                            }}
                        >
                            {this.state.memberList.map((item: any, index: number) => {
                                return <motion.div key={'member-page-'+item.user_id}
                                    className='member-item'
                                    style={{
                                        opacity: this.state.crrOpenMemberModal == item.user_id ? 0 : 1
                                    }}
                                    onClick={() => {
                                        if(this.context.project != null && this.context.project!.rolePower! >= 2
                                            && this.context.project!.rolePower! >= item.role_power
                                            && this.context.auth.user?.user_id != item.user_id
                                        ) {
                                            this.setState({
                                                crrOpenMemberModal: item.user_id
                                            })
                                        }
                                        
                                    }}
                                >
                                    <motion.div className='sub'
                                        layoutId={'member-modal-a' + item.user_id + '-panel'}
                                    >
                                        <motion.div
                                            className='circle-image'
                                            layoutId={'member-modal-a' + item.user_id + '-image'}
                                            style={{
                                                backgroundImage: 'url(' + (item.user.image_url ? configs.getAssetUrl() + item.user.image_url : 'https://gravatar.com/avatar/' + item.user.user_id + '?s=400&d=retro&r=x') + ')'
                                            }}
                                        >
                                            {/* { item.user.image_url == null && <motion.div className='centerContain'>
                                                <FontAwesomeIcon icon={faUser} fontSize={60} style={{
                                                    color: 'rgba(255, 255, 255, .75)'
                                                }}/>
                                            </motion.div>} */}
                                        </motion.div>

                                        <motion.div className='info'>
                                            <motion.p className='member-name'>{item.user.username}</motion.p>
                                            <motion.p className='detail'
                                                onClick={(e) => {
                                                    
                                                }}
                                            >{getRolePowerName(item.role_power)}</motion.p>
                                        </motion.div>
                                    </motion.div>
                                </motion.div>
                            })}
                        </motion.div>
                        
                    }
                </motion.div>
            </>
        );
    }
}

MembersPage.contextType = AppContextState;

export default MembersPage;